import ToastVue from "@common/components/Toast.vue";
import { SnackOptions, ToastOptions, ToastPositions } from "@medapro-types/common/components/Toast";
import emitter from "tiny-emitter/instance";
import { h, render, nextTick } from "vue";

export const createContainer = (position: ToastPositions) => {
  const existingContainer = document.querySelector(`.toast-container.${position}`);
  if (existingContainer) return existingContainer;
  const container = document.createElement("div");
  container.classList.add("toast-container", position);
  document.body.appendChild(container);

  const containerContent = document.createElement("div");
  containerContent.classList.add("toast-content-container", position);
  container.appendChild(containerContent);

  return container;
};

export const removeEmptyContainer = (position: ToastPositions) => {
  const existingContainer = document.querySelector(`.toast-container.${position}`);
  if (existingContainer && existingContainer.querySelectorAll(".toast-content-container > *").length === 0) {
    document.body.removeChild(existingContainer);
  }
};

export function useToast() {
  const createToast = async (options: ToastOptions) => {
    createContainer(options.position ?? "top-right");

    const toast = h(ToastVue);
    await nextTick(async () => {
      const childElem = document.createElement("div");
      childElem.classList.add("toast-wrapper");
      render(toast, childElem);

      toast.component?.exposed?.show(options);
    });
  };

  const closeToast = (id: string) => {
    emitter.emit("close-toast-by-id", { id });
  };

  const createSnackbar = (options: SnackOptions) => {
    const snackBarOptions = Object.assign(options, { snackBar: true, position: options.position ?? "bottom" });
    createToast(snackBarOptions);
  };

  return { createToast, closeToast, createSnackbar };
}
